<template>
  <v-dialog
      v-model="value"
      persistent
      :max-width="maxWidth"
      >
      <v-card
               
      >
          <v-card-title
            class="text-h5"
          >
            {{title}}
          </v-card-title>

          <v-card-text
            style="min-height: 500px;"
          >
       
            <pc-detail
              v-if="selectedPC"
              :personalCoverage="selectedPC"
              :reload="reloadPC"
              :filters="filters"
              :group_id="group_id"
              :pod="pod"
              :key="`pcdetail_${selectedPC.id}`"
              @changed="PCChanged"
            />
            <pc-list
              v-else
              :personalCoverages="personalCoverages"
              :filters="filters"
            />
      
          </v-card-text>
          <v-card-actions>
            
              <v-btn
                @click="doNew()"
                v-if="selectedPC ? false : true"
              >
                New Personal Coverage
              </v-btn>   

            <v-spacer></v-spacer>
              <v-btn
                @click="save()"
                v-if="state.startsWith('detail')"
                :disabled="saveDisabled"
                :loading="saving"
                width="80"
              >
                Save
              </v-btn>              


              <v-btn
                @click="cancel()"
                width="80"
              >
                {{cancelCaption}}
              </v-btn>              

          </v-card-actions>          
      </v-card>

  </v-dialog>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import schedulePCList from '@/views/apps/scheduling-new/components/schedulePCList';
import schedulePCDetail from '@/views/apps/scheduling-new/components/schedulePCDetail';

  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },
      'max-width': {
        default: '500',
        type: String
      },
      personalCoverages: {
          type: Array,
          default: () => []
      },
      filters: {
          type: Array,
          default: () => []
      },      
      title: {
        default: 'Personal Coverages',
        type: String
      },
      group_id: {
          type: String,
          default: ''
      },     
      pod: {
          type: Object,
          default: () => {}
      },                             
    },
    components: {
        'pc-list': schedulePCList,   
        'pc-detail': schedulePCDetail
    },    
    data: () => ({
      selectedPC: null,
      currentPC: 0,
      reloadPC: '',
      PCEdits: {},
      saving: false
    }),
    mounted() {
    },
    methods: {

      arrayString(arr) {   

        if (!arr) {
          arr = []
        }     
        let temp = JSON.parse(JSON.stringify(arr))

        let temp2 = temp.sort()
        
        return temp2.join(',')
      },
      
      PCChanged (props) {
        for (let prop in props) {
          
          switch (prop) {
            //case 'rounding_outpatient':

              //break
            default:
              this.$set(this.PCEdits,prop,props[prop])
              break
          }
        }

      },

      doNew () {
        this.currentPC += 1
        this.selectedPC = {
          id: -1 * this.currentPC
        }

        this.reloadPC = (new Date()).toISOString()
      },
      cancel () {

        if (this.state === 'detail_dirty') {
          this.PCEdits = {}
        } else if (this.state === 'detail') {
          this.selectedPC = null
        } else {
          this.$emit('input', false)          
        }
      },
      saveFinished (success)  {

        if (success) {
          this.reloadPC = (new Date()).toISOString()
          this.selectedPC = null
        }
        this.saving = false
      },
      async save () {

        this.saving = true

        let params = {}

        for (let prop in this.PCEdits) {
          params[prop] = this.PCEdits[prop]
        }

        params.callback = this.saveFinished

        this.$emit('savePC', params)
      },      
    },
    computed: {
      saveDisabled () {

        if (!this.PCEdits.coverer) {
          return true
        }
        if (!this.PCEdits.coveree) {
          return true
        }        
        if (!this.PCEdits.startDate) {
          return true
        }
        if (!this.PCEdits.endDate) {
          return true
        }
        if (!this.PCEdits.startTime) {
          return true
        }
        if (!this.PCEdits.endTime) {
          return true
        }

        let start = `${this.PCEdits.startDate}_${this.PCEdits.startTime}`
        let end = `${this.PCEdits.endDate}_${this.PCEdits.endTime}`
        if (start >= end) {
          return true
        }

        
        return this.state !== 'detail_dirty'
      },
      state () {
        if (!this.selectedPC) {
          return 'list'
        } else {
          if (this.PCDirty) {
            return 'detail_dirty'
          } else {
            return 'detail'
          }
        }        
      },
      cancelCaption () {
        switch (this.state) {
          case 'detail':
            return 'Back'
          case 'detail_dirty':
            return 'Cancel'
          default:
            return 'Close'          
        }
      },

      PCDirty () {

        let dirty = false
        for (let prop in this.PCEdits) {

          dirty = true
        }

        return dirty
      },

    },
    watch: {
        value (newValue, oldValue) {
          this.selectedPC = null
        },
    }
  }
</script>

